export default "<ion-header>\n\t<app-toolbar></app-toolbar>\n</ion-header>\n\n<ion-content>\n\t<app-order-content></app-order-content>\n</ion-content>\n";